import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsSuggestIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_suggest"}/>
}
